// eslint-disable-next-line
export const isDeepEqual = (a: any, b: any): boolean => {
  if (a === b) return true

  if (typeof a != 'object' || typeof b != 'object' || a == null || b == null) return false

  const keysA = Object.keys(a),
    keysB = Object.keys(b)

  if (keysA.length != keysB.length) return false

  for (const key of keysA) {
    if (!keysB.includes(key)) return false

    if (typeof a[key] === 'function' || typeof b[key] === 'function') {
      if (a[key].toString() != b[key].toString()) return false
    } else {
      if (!isDeepEqual(a[key], b[key])) return false
    }
  }

  return true
}

export const removeEmptyAttribute = (object: Record<string, unknown>): Record<string, unknown> => {
  return Object.fromEntries(Object.entries(object).filter(([, v]) => v !== '' && typeof v !== 'undefined'))
}
